import { lazy, Suspense, useMemo } from 'react'
import { RouteObject } from 'react-router'
import { QueryClient } from '@tanstack/react-query'
import { SkeletonPageLoading } from '@/components/shared/loading/page.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { importOrReload } from '@/lib/utils/dynamic-import.ts'
import { financialModelLoader } from '@/feature/financial-model/api/loader.ts'

const LazySettingsIndexRoute = lazy(() =>
  importOrReload(() =>
    import(`./route.tsx`).then(mod => ({
      default: mod.SettingsRoute
    }))
  )
)
const LazyCurrencySettingsRoute = lazy(() =>
  importOrReload(() =>
    import(`./currency/route.tsx`).then(mod => ({
      default: mod.FinancialModelCurrencySettingsRoute
    }))
  )
)

const LazyFiscalYearEndSettingsRoute = lazy(() =>
  importOrReload(() =>
    import(`./fiscal-year-end/route.tsx`).then(mod => ({
      default: mod.FinancialModelFiscalYearEndSettingsRoute
    }))
  )
)

const LazyTimeframeSettingsRoute = lazy(() =>
  importOrReload(() =>
    import(`./timeframe/route.tsx`).then(mod => ({
      default: mod.FinancialModelTimeframeSettingsRoute
    }))
  )
)

const LazyGeneralSettingsRoute = lazy(() =>
  importOrReload(() =>
    import(`./general/route.tsx`).then(mod => ({
      default: mod.FinancialModelGeneralSettingsRoute
    }))
  )
)
// const LazyFinancialModelUpdateSettingsRoute = lazy(() =>
//   importOrReload(() =>
//     import(`./financial-model-update/route.tsx`).then((mod) => ({
//       default: mod.FinancialModelUpdateSettingsRoute,
//     }))
//   )
// )

export const useFinancialModelSettingsRoute = (props: { queryClient: QueryClient }): RouteObject[] =>
  useMemo(
    () => [
      {
        path: `settings`,
        element: <LazySettingsIndexRoute />,
        loader: financialModelLoader(props.queryClient),
        hydrateFallbackElement: <SkeletonPageLoading />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Skeleton className={`h-full w-full`} />}>
                <LazyGeneralSettingsRoute />
              </Suspense>
            )
          },
          {
            path: `general`,
            element: (
              <Suspense fallback={<Skeleton className={`h-full w-full`} />}>
                <LazyGeneralSettingsRoute />
              </Suspense>
            )
          },
          {
            path: `currency`,
            element: (
              <Suspense fallback={<Skeleton className={`h-full w-full`} />}>
                <LazyCurrencySettingsRoute />
              </Suspense>
            )
          },
          {
            path: `fiscal-year-end`,
            element: (
              <Suspense fallback={<Skeleton className={`h-full w-full`} />}>
                <LazyFiscalYearEndSettingsRoute />
              </Suspense>
            )
          },
          {
            path: `timeframe`,
            element: (
              <Suspense fallback={<Skeleton className={`h-full w-full`} />}>
                <LazyTimeframeSettingsRoute />
              </Suspense>
            )
          }
          // {
          //   path: `financial-model-update`,
          //   element: (
          //     <Suspense fallback={<Skeleton className={`w-full h-full`} />}>
          //       <LazyFinancialModelUpdateSettingsRoute />
          //     </Suspense>
          //   ),
          // },
        ]
      }
    ],
    [props.queryClient]
  )
